export var ZoneType;
(function (ZoneType) {
    ZoneType["Default"] = "default";
    ZoneType["ResponseArea"] = "responseArea";
    ZoneType["PoliceDepartment"] = "policeDepartment";
})(ZoneType || (ZoneType = {}));
